export enum CodigoIdiomaEnum {

  PT_BR = "pt_BR",
  EN_US = "en_US",
  ES_ES = "es_ES"

}
